import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlize'
})
export class HtmlizePipe implements PipeTransform {

    public transform(text: string): string {
        return text ? text
            .split('&lt;')
            .join('<')
            .split('&gt;')
            .join('>')
            .split('<li>')
            .join('<li> - '):
            null;
    }
}
